import { session } from '@farmersdog/utils';

export const KEY = 'referred-by-vet';

interface ReferredByVetFresh {
  freshRecipeNames: string[];
  diyRecipeDisplayNames?: never;
}

interface ReferredByVetDIY {
  freshRecipeNames?: never;
  diyRecipeDisplayNames: string[];
}

export type ReferredByVet = {
  dogName: string;
  vetName: string;
} & (ReferredByVetFresh | ReferredByVetDIY);

export type VetCustomPlanType = ReferredByVet | undefined;

function get(): string | null {
  return session.getItem(KEY);
}

function set(value: string): void {
  session.setItem(KEY, value);
}

function remove(): void {
  session.removeItem(KEY);
}

function getParsed(sessionString: string): VetCustomPlanType {
  try {
    return JSON.parse(sessionString) as VetCustomPlanType;
  } catch {
    return undefined;
  }
}

export const referredByVet = {
  get,
  set,
  remove,
  getParsed,
};
